import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import { appIcons } from './icons'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Local Storage - Theme
let darkTheme = true;
if (localStorage.getItem('darkTheme')) {
    try {
        darkTheme = JSON.parse(localStorage.getItem('darkTheme'));
    } catch (e) {
        localStorage.removeItem('darkTheme');
    }
}

export default createVuetify({
    components,
    directives,
    defaults: {
        VTextField: { variant: 'underlined' },
        VTextarea: { variant: 'underlined' },
        VSelect: { variant: 'underlined' },
        VAutocomplete: { variant: 'underlined' },
    },
    icons: {
        defaultSet: 'mdi',
        aliases: {
            ...aliases,
            ...appIcons,
        },
        sets: { mdi },
    },
    theme: {
        defaultTheme: darkTheme ? 'dark' : 'light',
        themes: {
            dark: {
                dark: true,
                colors: {
                    background: '#212121',
                    surface: '#363636',
                    'surface-variant': 'rgb(58, 58, 58)',
                    'outline': '#8a8a87',
                    primary: '#E6E6E6',
                    info: '#008DF2',
                    success: '#38c172',
                    secondary: '#1565c0',
                    accent: '#FF4E00',
                    error: '#FF1589',
                    light: '#E6E6E6',
                    fluxOrange: '#FF4E00',
                    fluxPurple: '#AC00FF',
                    fluxYellow: '#FAFF00',
                },
            },
            light: {
                dark: false,
                colors: {
                    background: 'rgb(255,255,255)',
                    surface: 'rgb(249,249,249)',
                    'surface-variant': '#eeeeee',
                    'outline': '#d9d9d6',
                    primary: '#000050',
                    info: '#008DF2',
                    success: '#38c172',
                    secondary: '#008DF2',
                    accent: '#FF4E00',
                    error: '#FF1589',
                    light: '#E6E6E6',
                    fluxOrange: '#FF4E00',
                    fluxPurple: '#AC00FF',
                    fluxYellow: '#FAFF00',
                },
            },
        },
    },
})
